import templateUrl from "emun.on-demand/admin/edit-product-prompt.htm";
import EditProductPromptController from "emun.on-demand/admin/edit-product-prompt.controller";
import open from "webmodals/open";

let editProductPrompt = options => {
  let modalInstance = open({
    size: options.size || "xl",
    templateUrl: options.templateUrl || templateUrl,
    controller: EditProductPromptController,
    bindToController: true,
    controllerAs: "$ctrl",
    resolve: {
      options: () => options
    }
  });

  return modalInstance.result;
};

export default editProductPrompt;
